import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import Loading from "components/Loading";
import SpyFilter from "../filter";
import { getShops, getShopTrend } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import { ReactTableDataGrid } from "components/Table";
import { heightRow, CATEGORIES } from "../constant";
import useColumnTableShop from "../hooks/useColumnTableShop";
import { getQueryParams } from "components/Function";

const limit = 20;

const SpyAdvancedShops = ({ getShops, getShopTrend }) => {
    const { filter: initialFilter, page: initialPage } = getQueryParams();
    const [filter, setFilter] = useState(initialFilter);
    const [search, setSearch] = useState(initialFilter.keyword || "");
    const [page, setPage] = useState(initialPage);
    const params = useMemo(() => ({ ...filter, page, per_page: limit }), [filter, page]);
    const { data, loading } = useCallApi(getShops, params);
    const shopIds = useMemo(() => {
        return data?.data?.map((item) => item.seller_id).join(",");
    }, [data]);
    const { data: shopTrendData } = useCallApi(getShopTrend, shopIds, Boolean(shopIds));
    const columns = useColumnTableShop(heightRow, shopTrendData, filter.dateRange);

    useEffect(() => {
        const params = new URLSearchParams({ ...filter, page });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter, page]);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <div className="card mb-5 mb-xl-10">
            <Loading isLoading={loading} />
            <div className="card-body">
                <div className="row mb-10">
                    <div className="col-md-4 d-flex align-items-center">
                        <h1 className="mb-0">Shop</h1>
                    </div>
                    <div className="col-md-8 position-relative">
                        <div className="input-group h-100">
                            <input
                                type="text"
                                className="form-control rounded-end rounded-pill"
                                placeholder="Search..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <button
                                className="btn btn-info rounded-start rounded-pill"
                                type="button"
                                onClick={() => {
                                    setFilter((prev) => ({ ...prev, keyword: search }));
                                    setPage(1);
                                }}
                            >
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <SpyFilter
                    filter={filter}
                    setFilter={(data) => {
                        setFilter(data);
                        setPage(1);
                    }}
                    filterCategory={[
                        {
                            label: "Product Category",
                            key: "product_categories",
                            data: CATEGORIES,
                        },
                    ]}
                    filterShows={[
                        { label: "Region", value: "region", defaultValue: "US" },
                        { label: "30 days Sales", value: "total_sale_nd_cnt" },
                        { label: "Total Sales", value: "total_sale_cnt" },
                        { label: "Experience Points", value: "seller_rating" },
                        { label: "GMV", value: "total_sale_gmv_amt" },
                    ]}
                    filterAdvancedShows={[
                        { label: "Influencers", value: "related_influencers" },
                        { label: "Delivery Type", value: "seller_type" },
                        { label: "Main Sales Methods", value: "sales_flag" },
                        { label: "Sales trends", value: "sales_trend_flag" },
                        { label: "S Shop", value: "is_s_shop" },
                        { label: "Date Range", value: "dateRange", defaultValue: "30" },
                    ]}
                />
                <div className="mt-10">
                    <ReactTableDataGrid
                        tableName="shopSpyAdvanced"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                    />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { getShops, getShopTrend })(SpyAdvancedShops);
